import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=1eb8142c&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbItem: require('/vercel/path0/frontend/components/ui/BreadcrumbItem.vue').default,Breadcrumb: require('/vercel/path0/frontend/components/ui/Breadcrumb.vue').default,ArticlesDetailContent: require('/vercel/path0/frontend/components/articles/ArticlesDetailContent.vue').default,ArticleAuthor: require('/vercel/path0/frontend/components/ui/ArticleAuthor.vue').default,ArticlesArticleItem: require('/vercel/path0/frontend/components/articles/ArticlesArticleItem.vue').default,Button: require('/vercel/path0/frontend/components/ui/Button.vue').default})
